// extracted by css-extract-rspack-plugin
export default {"cls1":"FullScreenPremiumModal-cls1_eAU","cls2":"FullScreenPremiumModal-cls2_PIW FullScreenPremiumModal-cls1_eAU"};